module.exports = __webpack_public_path__ + "static/img/311.c5f08770.jpg";